export const lowItemReducer = (state = false, action) => {
  switch (action.type) {
    case "TOGGLE_LOW_ITEM":
      return action.value;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/salesLoader/lowItemsReducer.js